import { Model } from '@app/models/model';
import { DateTime, Duration } from 'luxon';

export class WaterStatus extends Model {
    active: boolean;
    datetime: string;
    gpm: number;
}

export class LeakStatus extends Model {
    active: boolean;
    leak_id?: number;
    data: any[];
}

export class ActiveLeak extends Model {
    id: number;
    device_id: string;
    type: string;
    start_datetime: string;
    end_datetime: string;
    total_gallons: string;
    gallons: string;
    total_gpm: string;
    gpm: string;
    recent_usage_query: {
        request_id: string;
        bucket: string;
        tz: string;
        since_datetime: string;
        until_datetime: string;
        group_multiplier: number;
    };

    // front
    start?: DateTime;
    end?: DateTime;
    duration?: Duration;
    flowrate?: string;
}
